import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Badge } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/ThermilifStyle.css";
import thermilifHeroImage from '../Assets/thermdev.png';

import thermilifCartridges from '../Assets/thermcart.png';
import thermilifDisplay from '../Assets/thermdis.png';
import thermilifBackground from '../Assets/thermbb.png';
import thermilifLayers from '../Assets/thermbef.png';

const ThermilifPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: false
    });
  }, []);

  const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/THERMILIF.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'thermilif-hifu.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/THERMILIF.pdf", '_blank');
    });
};
  

  // Technology features
  const technologies = [
    {
      id: 1,
      title: "Bipolar RF",
      description: "Induces controlled dermal heating for collagen stimulation",
      icon: "fas fa-bolt",
      color: "#FF6B6B"
    },
    {
      id: 2,
      title: "MFU",
      description: "Micro-Focused Ultrasound for precise deep tissue targeting",
      icon: "fas fa-wave-square",
      color: "#4ECDC4"
    },
    {
      id: 3,
      title: "SD Technology",
      description: "Synergy Dotting for multi-layer energy delivery",
      icon: "fas fa-dot-circle",
      color: "#FFD166"
    }
  ];

  // Cartridge types
  const cartridges = [
    {
      type: "SD Cartridges",
      count: "4 Types",
      applications: ["Face & Neck", "Body"],
      depths: ["1.5mm", "3.0mm", "4.5mm", "9.0mm"],
      icon: "fas fa-circle"
    },
    {
      type: "FL Cartridges",
      count: "6 Types",
      applications: ["Face & Neck", "Body"],
      depths: ["1.5mm", "2.0mm", "3.0mm", "4.5mm", "6.0mm", "9.0mm"],
      icon: "fas fa-grip-lines"
    }
  ];

  // Treatment areas
  const treatmentAreas = [
    {
      area: "Face",
      depth: "1.5mm - 4.5mm",
      description: "Targets epidermis, dermis, and superficial layers",
      icon: "fas fa-smile"
    },
    {
      area: "Neck",
      depth: "1.5mm",
      description: "Lifts and tightens neck contours",
      icon: "fas fa-user"
    },
    {
      area: "Body",
      depth: "6.0mm - 9.0mm",
      description: "Reaches deep fascia and SMAS layers",
      icon: "fas fa-user-md"
    }
  ];

  // Safety features
  const safetyFeatures = [
    {
      name: "Smart SD Rotation Sensor",
      description: "Prevents repeated treatment of same area",
      icon: "fas fa-sync-alt"
    },
    {
      name: "Smart Contact Sensor",
      description: "Energy output only with full skin contact",
      icon: "fas fa-hand-paper"
    },
    {
      name: "2-Layer Safety Guarantee",
      description: "Dual patent-approved security system",
      icon: "fas fa-shield-alt"
    }
  ];

  // Treatment timeline
  const timeline = [
    {
      time: "Immediate",
      result: "50% Improvement",
      description: "Visible lifting immediately after treatment"
    },
    {
      time: "After Treatment",
      result: "70% Improvement",
      description: "Progressive results post-treatment"
    },
    {
      time: "3-6 Months",
      result: "Peak Results",
      description: "Maximum collagen regeneration achieved"
    }
  ];

  return (
    <div className="thermilif-product-page">
      {/* Hero Section with Particle Background */}
      <section 
        className="thermilif-hero-section" 
        style={{ backgroundImage: `url(${thermilifBackground})` }}
      >
        <div className="particles-container">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}></div>
          ))}
        </div>
        
        <Container>
          <Row className="align-items-center min-vh-80">
            <Col md={5} className="hero-content" data-aos="fade-right">
              <Badge bg="light" text="dark" className="mb-3" data-aos="fade-up">
                <i className="fas fa-star me-2"></i>
                World-First Technology
              </Badge>
              <h1 className="product-title animate-charcter-thermilif">
                EPILYUM THERMILIF
              </h1>
              <h2 className="product-subtitle typed-text">
                Three Technologies, One Machine
              </h2>
              <p className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                HIFU System with Bipolar RF, SD Dotting & MFU
              </p>
              
              <div className="tech-badges" data-aos="fade-up" data-aos-delay="300">
                {technologies.map(tech => (
                  <span key={tech.id} className="tech-badge" style={{ borderColor: tech.color }}>
                    <i className={tech.icon} style={{ color: tech.color }}></i>
                    {tech.title}
                  </span>
                ))}
              </div>
            </Col>
            
            <Col md={7} className="text-center" data-aos="fade-left" data-aos-delay="200">
              <div className="device-container">
                <Image 
                  src={thermilifHeroImage} 
                  fluid 
                  className="product-hero-image thermilif-floating" 
                  alt="Thermilif HIFU Device"
                />
                <div className="energy-rings">
                  <div className="ring ring-1"></div>
                  <div className="ring ring-2"></div>
                  <div className="ring ring-3"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Technology Introduction */}
      <section className="tech-intro-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <div className="thermilif-icon mb-4" data-aos="zoom-in">
                <i className="fas fa-microscope"></i>
              </div>
              <h2 className="section-title thermilif-title mb-4">
                Revolutionary <span className="text-highlight">Synergy Technology</span>
              </h2>
              <p className="intro-text thermilif-description">
                Thermilif HIFU integrates the world's first technology combining Bipolar RF, 
                SD (Synergy Dotting), and MFU (Micro-Focused Ultrasound) to deliver a more 
                powerful, precise, and comprehensive rejuvenation treatment. This dual-modality 
                approach enhances tissue contraction and collagen synthesis at multiple depths.
              </p>
            </Col>
          </Row>
          
          {/* Technology Cards */}
          <Row className="g-4 mt-5">
            {technologies.map((tech, index) => (
              <Col lg={4} key={tech.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="tech-card" style={{ borderTopColor: tech.color }}>
                  <div className="tech-card-icon" style={{ color: tech.color }}>
                    <i className={tech.icon}></i>
                  </div>
                  <h4>{tech.title}</h4>
                  <p>{tech.description}</p>
                  <div className="tech-wave">
                    <div className="wave" style={{ background: tech.color }}></div>
                    <div className="wave" style={{ background: tech.color, animationDelay: '0.2s' }}></div>
                    <div className="wave" style={{ background: tech.color, animationDelay: '0.4s' }}></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Multi-Layer Treatment */}
      <section className="layers-section py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="layers-visualization">
                <Image 
                  src={thermilifLayers} 
                  fluid 
                  className="layers-image shadow-lg" 
                  alt="Multi-layer treatment visualization"
                />
                {/* <div className="layer-info" style={{ top: '10%', left: '60%' }} data-aos="fade-left">
                  <div className="layer-point" style={{ background: '#FF6B6B' }}></div>
                  <span>Epidermis</span>
                </div>
                <div className="layer-info" style={{ top: '30%', left: '50%' }} data-aos="fade-left" data-aos-delay="100">
                  <div className="layer-point" style={{ background: '#4ECDC4' }}></div>
                  <span>Dermis</span>
                </div>
                <div className="layer-info" style={{ top: '50%', left: '40%' }} data-aos="fade-left" data-aos-delay="200">
                  <div className="layer-point" style={{ background: '#FFD166' }}></div>
                  <span>SMAS Layer</span>
                </div>
                <div className="layer-info" style={{ top: '70%', left: '30%' }} data-aos="fade-left" data-aos-delay="300">
                  <div className="layer-point" style={{ background: '#95E1D3' }}></div>
                  <span>Deep Fascia</span>
                </div> */}
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title thermilif-title mb-4">
                Precision <span className="text-highlight">Multi-Layer Targeting</span>
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                Adjustable depth control allows practitioners to precisely target different 
                tissue layers, reaching deep fascia and SMAS layers for comprehensive treatment 
                of epidermis, dermis, fascia, and adipose tissues.
              </p>
              
              <div className="depth-list">
                {[1.5, 2, 3, 4.5, 6, 9].map((depth, index) => (
                  <div key={depth} className="depth-item" data-aos="fade-up" data-aos-delay={index * 50}>
                    <span className="depth-value">{depth}mm</span>
                    <span className="depth-label">
                      {depth <= 2 ? 'Superficial Dermis' : 
                       depth <= 4.5 ? 'Deep Dermis & Facial Layers' : 
                       'Body & Deep Tissue'}
                    </span>
                    <div className="depth-bar" style={{ 
                      width: `${(depth / 9) * 100}%`,
                      background: `linear-gradient(90deg, #FF6B6B, #${(depth * 27).toString(16).padStart(2, '0')}${(depth * 28).toString(16).padStart(2, '0')}${(depth * 29).toString(16).padStart(2, '0')})`
                    }}></div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Cartridges System */}
      <section className="cartridges-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermilif-title" data-aos="fade-up">
                4-in-1 <span className="text-highlight">Versatile System</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Quick-switch cartridges for face, neck, and body treatments
              </p>
            </Col>
          </Row>
          
          <Row className="g-4 align-items-center mb-5">
            <Col lg={6} data-aos="fade-right">
              <div className="cartridge-display">
                <Image 
                  src={thermilifCartridges} 
                  fluid 
                  className="cartridge-image floating-rotate" 
                  alt="Thermilif Cartridges"
                />
                <div className="cartridge-glow"></div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="cartridge-info">
                <h3 className="mb-4">Advanced Cartridge System</h3>
                
                {cartridges.map((cartridge, index) => (
                  <div key={index} className="cartridge-type mb-4">
                    <div className="cartridge-header">
                      <i className={cartridge.icon}></i>
                      <h4>{cartridge.type}</h4>
                      <Badge bg="primary" className="ms-2">{cartridge.count}</Badge>
                    </div>
                    
                    <div className="cartridge-details">
                      <div className="mb-2">
                        <strong>Applications:</strong>
                        <div className="tags mt-1">
                          {cartridge.applications.map((app, i) => (
                            <span key={i} className="tag">{app}</span>
                          ))}
                        </div>
                      </div>
                      
                      <div>
                        <strong>Depths:</strong>
                        <div className="depth-tags mt-1">
                          {cartridge.depths.map((depth, i) => (
                            <span key={i} className="depth-tag">{depth}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          
          {/* Treatment Areas */}
          <Row className="g-4">
            {treatmentAreas.map((area, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="treatment-area-card">
                  <div className="area-icon">
                    <i className={area.icon}></i>
                  </div>
                  <h4>{area.area}</h4>
                  <div className="area-depth">{area.depth}</div>
                  <p>{area.description}</p>
                  <div className="area-wave">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Safety Features */}
      <section className="safety-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermilif-title" data-aos="fade-up">
                Intelligent <span className="text-highlight">Safety System</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {safetyFeatures.map((feature, index) => (
              <Col lg={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="safety-card">
                  <div className="safety-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <h4>{feature.name}</h4>
                  <p>{feature.description}</p>
                  <div className="safety-shield">
                    <i className="fas fa-check"></i>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          
        
        </Container>
      </section>

      {/* Treatment Timeline */}
      <section className="timeline-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermilif-title" data-aos="fade-up">
                Progressive <span className="text-highlight">Results Timeline</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row>
            <Col lg={12}>
              <div className="timeline-container" data-aos="fade-up">
                <div className="timeline">
                  {timeline.map((stage, index) => (
                    <div key={index} className="timeline-item" data-aos="fade-up" data-aos-delay={index * 100}>
                      <div className="timeline-marker">
                        <div className="marker-circle"></div>
                      </div>
                      <div className="timeline-content">
                        <h4>{stage.time}</h4>
                        <div className="timeline-result">{stage.result}</div>
                        <p>{stage.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          
          {/* Results Stats */}
         
          
        </Container>
      </section>

      {/* Catalog Section */}
      <section className="thermilif-catalog-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title thermilif-title mb-4">
                Download <span className="text-highlight">Complete Catalogue</span>
              </h2>
              <p className="lead mb-5">
                Technical specifications, treatment protocols, and clinical guides
              </p>
              
              <div className="catalog-preview mb-5" data-aos="zoom-in">
                <div className="catalog-frame thermilif-catalog">
                  <div className="catalog-3d">
                    <div className="catalog-front">
                      <h3>THERMILIF HIFU</h3>
                      <p>Three Technologies, One Machine</p>
                      <div className="tech-tags">
                        <span>Bipolar RF</span>
                        <span>SD Dotting</span>
                        <span>MFU</span>
                      </div>
                    </div>
                    <div className="catalog-side"></div>
                  </div>
                  <div className="catalog-overlay" onClick={handleOpenPDF}>
                    <span className="overlay-text">View Full Specifications</span>
                  </div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download HIFU Catalogue (PDF)
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                <small>Includes all technical features and safety guidelines</small>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Warning Section */}
      <section className="warning-section py-4">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <div className="warning-alert" data-aos="fade-up">
                <div className="warning-icon">
                  <i className="fas fa-exclamation-triangle"></i>
                </div>
                <div className="warning-content">
                  <h5>Important Safety Information</h5>
                  <p>
                    HIFU devices are intended solely for use by qualified dermatologists. 
                    Incorrect settings or misuse may cause serious injury including burns, 
                    fat atrophy, or nerve damage. Always follow the manufacturer's safety guidelines.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ThermilifPage;